import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Button, ButtonGroup, IconButton, Tooltip, Typography } from "@material-ui/core";
import { Check, ExpandMore, FileCopyOutlined } from "@material-ui/icons";
import { requestExample } from "./helpers";
import useStyles from "./styles";

export function CopyButton({ text, label = "Copiar exemplo" }) {
  const classes = useStyles();
  const [feedback, setFeedback] = useState("");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setFeedback("Copiado");
    } catch (_) { setFeedback("Não foi possível copiar. Selecione o texto."); }
  };
  return <span>
    <Tooltip title={feedback || label}><IconButton className={classes.copy} size="small" aria-label={label} onClick={copy}>{feedback === "Copiado" ? <Check fontSize="small" /> : <FileCopyOutlined fontSize="small" />}</IconButton></Tooltip>
    {feedback && <span role="status" className={classes.feedback}>{feedback}</span>}
  </span>;
}

const optionalFields = [
  ["userId", "ID do atendente da mesma empresa. Atribui o atendimento a ele quando closeTicket é false."],
  ["queueId", "ID da fila, aplicado junto com userId. Se omitido ou não encontrado, usa a primeira fila da conexão."],
  ["sendSignature", "true inclui o nome do atendente no início da mensagem. Exige userId. Padrão: false."],
  ["closeTicket", "true solicita encerrar o atendimento após o envio e tem prioridade sobre a atribuição ao atendente. Padrão: false."]
];

export default function Reference({ mode, endpoint }) {
  const classes = useStyles();
  const [format, setFormat] = useState("json");
  const media = mode === "media";
  const example = requestExample(mode, media ? "curl" : format, endpoint);
  return <section className={classes.card} aria-label={media ? "Referência de arquivo" : "Referência de texto"}>
    <div className={classes.cardHeader}><Typography component="h2">Como integrar</Typography><span className={classes.muted}>{media ? "multipart/form-data" : "application/json"}</span></div>
    <div className={classes.cardBody}>
      <div className={classes.auth}>Autenticação no cabeçalho<code>Authorization: Bearer SEU_TOKEN_DA_CONEXAO</code></div>
      <div className={classes.codeToolbar}>
        {media ? <Typography className={classes.sectionTitle}>cURL · Bash</Typography> : <ButtonGroup size="small" aria-label="Formato do exemplo">
          <Button color={format === "json" ? "primary" : "default"} onClick={() => setFormat("json")} aria-pressed={format === "json"}>JSON</Button>
          <Button color={format === "curl" ? "primary" : "default"} onClick={() => setFormat("curl")} aria-pressed={format === "curl"}>cURL · Bash</Button>
        </ButtonGroup>}
        <CopyButton key={`${mode}-${format}`} text={example} />
      </div>
      <pre className={classes.code}>{example}</pre>
      <dl className={classes.fields}>
        <div><dt><code>number</code><span className={classes.required}>Obrigatório</span></dt><dd>Número com DDI e DDD, somente dígitos. Exemplo: 5551999999999.</dd></div>
        {media && <div><dt><code>medias</code><span className={classes.required}>Obrigatório</span></dt><dd>Arquivo anexado ao formulário. Não envie o caminho como texto nem como JSON.</dd></div>}
        <div><dt><code>body</code>{!media && <span className={classes.required}>Obrigatório</span>}</dt><dd>{media ? "Legenda do arquivo. Se ficar vazia, será usado o nome do arquivo." : "Texto da mensagem que o cliente vai receber."}</dd></div>
      </dl>
      <Accordion className={classes.accordion}>
        <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMore />}><Typography className={classes.stepTitle}>Campos opcionais</Typography></AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <dl className={classes.fields}>{optionalFields.map(([key, description]) => <div key={key}><dt><code>{key}</code></dt><dd>{description}</dd></div>)}</dl>
          <Typography className={classes.muted}>{media ? "No multipart, envie as flags como true ou false. O navegador define o Content-Type com o boundary ao usar FormData." : "No JSON, use true ou false sem aspas para as flags."}</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className={classes.accordion}>
        <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMore />}><Typography className={classes.stepTitle}>Respostas da API</Typography></AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <pre className={classes.code}>{'HTTP 200\n{ "status": "SUCCESS" }'}</pre>
          <Typography className={classes.muted}>A solicitação foi processada. Esta resposta não confirma entrega ou leitura pelo cliente.</Typography>
          <dl className={classes.fields}>
            <div><dt>401 · Token ausente ou inválido</dt><dd>Copie o token da conexão em Conexões → Editar.</dd></div>
            <div><dt>400 · Não foi possível enviar</dt><dd>Confira os campos e se o WhatsApp está conectado. O corpo da resposta informa o erro.</dd></div>
            <div><dt>Sem resposta</dt><dd>Confira o atendimento antes de repetir: o envio pode ter sido processado.</dd></div>
          </dl>
        </AccordionDetails>
      </Accordion>
    </div>
  </section>;
}
